<div id="gameCategory-tab" class="owl-tab owl-carousel image-carousel carousel-widget owl-loaded owl-drag">

    <!-- <div>
        <div class="demomode-note" *ngIf="(isDemo$ | async) && (isSlotsPage$ | async)">
            {{ 'Any wins or losses will not affect your Main Wallet\'s balance' | translate }}
        </div>
    </div> -->
    <ng-container *ngIf="providerslist !== [] && !isSkeletonProvidersList; else skeletonProviderslist">
        <div class="owl-stage-outer top-radius">
        <div class="owl-stage">
            
            <ng-container *ngFor="let providerCode of providerslist;" >
                <div class="category-tabs mr-0" *ngIf="availableProvider !== null &&  availableProvider[providerCode] && availableProvider[providerCode].length > 0">
                    <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab(providerCode, gameCategoriesList[providerCode]['name'].toLowerCase())">
                        <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute(gameCategoriesList[providerCode]['name'].toLowerCase()) ? 'active-category-tab' : ''">
                            <span [innerHtml]="svg[providerCode+(environment.projectCode === 'qp20' || environment.projectCode === 'qp20-dark' ? 'QP20Icon' : 'Icon')] | safeHtml"></span>
                            <p>{{ gameCategoriesList[providerCode].title ? (gameCategoriesList[providerCode].title == 'Crickets' ? (gameCategoriesList[providerCode].title | translate) : gameCategoriesList[providerCode].title) : (gameCategoriesList[providerCode].name == 'Crickets' ? (gameCategoriesList[providerCode].name | translate) : gameCategoriesList[providerCode].name) }}</p>
                        </div>
                    </div>
                </div>
            </ng-container>
            

            <!-- Display Sports category on first position for QP13 -->
            <!-- <ng-container *ngIf="projectCode === 'qp13'">
                <div class="category-tabs mr-0" *ngIf="availableProvider !== null &&  availableProvider.SP?.length > 0">
                    <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab('SP', 'sports')">
                        <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute('sports') ? 'active-category-tab' : ''">
                            <a class="margin-auto">
                                <span [innerHtml]="svg.casinoIcon | safeHtml"></span>
                                <p>{{ 'Casino' | translate }}</p>
                            </a>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="category-tabs mr-0" *ngIf="availableProvider !== null &&  availableProvider.LC?.length > 0">
                <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab('LC', 'casino')">
                    <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute('casino') ? 'active-category-tab' : ''">
                        <a class="margin-auto">
                            <span [innerHtml]="svg.casinoIcon | safeHtml"></span>
                            <p>{{ 'Casino' | translate }}</p>
                        </a>
                    </div>
                </div>
            </div>
            <div class="category-tabs mr-0" *ngIf="availableProvider !== null &&  availableProvider.SL?.length > 0">
                <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab('SL', 'slots')">
                    <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute('slots') ? 'active-category-tab' : ''">
                        <a class="margin-auto">
                            <span [innerHtml]="svg.slotsIcon | safeHtml"></span>
                            <p>{{ 'Slots' | translate }}</p>
                        </a>
                    </div>
                </div>
            </div>
            <div class="category-tabs mr-0" *ngIf="availableProvider !== null &&  availableProvider.FS?.length > 0">
                <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab('FS', 'fishing')">
                    <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute('fishing') ? 'active-category-tab' : ''">
                        <a class="margin-auto">
                            <span [innerHtml]="svg.fishingIcon | safeHtml"></span>
                            <p>{{ 'Fishing' | translate }}</p>
                        </a>
                    </div>
                </div>
            </div> -->
            <!-- Display Sports category on forth position for others project -->
            <!-- <ng-container *ngIf="projectCode !== 'qp13'">
                <div class="category-tabs mr-0" *ngIf="availableProvider !== null &&  availableProvider.SP?.length > 0">
                    <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab('SP', 'sports')">
                        <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute('sports') ? 'active-category-tab' : ''">
                            <a class="margin-auto">
                                <span [innerHtml]="svg.slotsIcon | safeHtml"></span>
                                <p>{{ 'Slots' | translate }}</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="category-tabs mr-0" *ngIf="availableProvider !== null &&  availableProvider.FS?.length > 0">
                    <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab('FS', 'fishing')">
                        <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute('fishing') ? 'active-category-tab' : ''">
                            <a class="margin-auto">
                                <span [innerHtml]="svg.fishingIcon | safeHtml"></span>
                                <p>{{ 'Fishing' | translate }}</p>
                            </a>
                        </div>
                    </div>
                </div> -->
                <!-- Display Sports category on forth position for others project -->
                <!-- <ng-container *ngIf="projectCode !== 'qp13'">
                    <div class="category-tabs mr-0" *ngIf="availableProvider.SP?.length > 0">
                        <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab('SP', 'sports')">
                            <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute('sports') ? 'active-category-tab' : ''">
                                <a class="margin-auto">
                                    <span [innerHtml]="svg.sportsIcon | safeHtml"></span>
                                    <p>{{ 'Sports' | translate }}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="category-tabs mr-0" *ngIf="availableProvider !== null &&  availableProvider.ES?.length > 0">
                    <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab('ES', 'esports')">
                        <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute('esports') ? 'active-category-tab' : ''">
                            <a class="margin-auto">
                                <span [innerHtml]="svg.esportsIcon | safeHtml"></span>
                                <p>{{ 'Esports' | translate }}</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="category-tabs mr-0" *ngIf="availableProvider !== null && availableProvider.CF?.length > 0">
                    <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab('CF', 'cock-fighting')">
                        <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute('cock-fighting') ? 'active-category-tab' : ''">
                            <a class="margin-auto">
                                <span [innerHtml]="svg.cockFightingIcon | safeHtml"></span>
                                <p>{{ 'Cock Fighting' | translate }}</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="category-tabs mr-0" *ngIf="availableProvider !== null &&  availableProvider.CR?.length > 0">
                    <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab('CR', 'crickets')">
                        <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute('crickets') ? 'active-category-tab' : ''">
                            <a class="margin-auto">
                                <span [innerHtml]="svg.cricketsIcon | safeHtml"></span>
                                <p>{{ 'Crickets' | translate }}</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="category-tabs mr-0" *ngIf="availableProvider !== null &&  availableProvider.LT?.length > 0">
                    <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab('LT', 'lottery')">
                        <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute('lottery') ? 'active-category-tab' : ''">
                            <a class="margin-auto">
                                <span [innerHtml]="svg.lotteryIcon | safeHtml"></span>
                                <p>{{ 'Lottery' | translate }}</p>
                            </a>
                        </div>
                    </div>
                </div> -->
                <!-- </div>
                <div class="category-tabs mr-0" *ngIf="availableProvider !== null && availableProvider.CG?.length > 0">
                    <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab('CG', 'crash-game')">
                        <div class="oc-item game-tab vertical-center text-center" [ngClass]="isBelongFromRoute('crash-game') ? 'active-category-tab' : ''">
                            <a class="margin-auto">
                                <span [innerHtml]="svg.crashGameIcon | safeHtml"></span>
                                <p>{{ 'Crash Game' | translate }}</p>
                            </a>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="category-tabs m-r-0">
                    <div *ngFor="let tab of tabs; let i = index" [ngClass]="{'m-0': fixed, 'd-none': showPokerTab === false && tab.code === 'PK', 'active-tab': i === activeTabIndex}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'" (click)="onSelectCategoryTab(tab.code, tab.link, i)">
                        <div class="oc-item casino-tab" [ngClass]="isBelongFromRoute(tab.link) ? 'active-category-tab' : ''">
                            <a>
                                <span [innerHTML]="svg[tab.link + 'Icon'] | safeHtml"></span>
                                <p [ngClass]="{'tab-gradient': (tabs.length > 9 && tabs.length < 12) && activeTabIndex !== i, 'tab-gradient-more': tabs.length >= 12 && activeTabIndex !== i}">{{ tab.name | translate }}</p>
                            </a>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </ng-container>

     <!-- <div class="demomode-bar" *ngIf="(isSlotsPage$ | async) === true">
        <p class="pre-text">{{ 'Demo Mode' | translate }} <span class="info" (click)="onShowDemoNotice()">i</span></p>
        <label class="switch">
            <input type="checkbox" [checked]="isDemo$ | async" (change)="onDemoMode($event)">
            <div class="slider round">
                <span class="on">{{ 'On' | translate | uppercase }}</span>
                <span class="off">{{ 'Off' | translate | uppercase }}</span>
            </div>
        </label>
    </div> -->

    <!-- Skeleton Loading -->
    <ng-template #skeletonProviderslist>
        <ng-container *ngIf="isSkeletonProvidersList">
            <div class="owl-stage-outer top-radius">
                <div class="owl-stage">
                    <ng-container *ngFor="let item of [].constructor(8); let i = index">
                        <div class="category-tabs mr-0">
                            <div [ngClass]="{'m-0': fixed}" class="owl-item" [style]="'width: ' + minTabWidth + '%;'">
                                <div class="oc-item game-tab vertical-center text-center">
                                    <a class="margin-auto">
                                        <span class="skeleton skeleton-game-menu">
                                            <svg></svg>
                                        </span>
                                        <p class="skeleton skeleton-game-menu-title">Skeleton</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        </ng-template>
</div>
